import { useCallback } from 'react';
import {
    GetCalendarReminderWidgetDocument,
    UserDisplayedWidgetClassEnum,
    getApolloErrorUiMessage,
    useMarkWidgetAsDisplayedMutation,
} from '@lingoda/monolith-graphql';
import { trans } from '@lingoda/i18n';
import { showErrorToast } from '@lingoda/toasts';

export const useMarkConnectCalendarDialogAsDismissed = () => {
    const [markAsDisplayedMutation] = useMarkWidgetAsDisplayedMutation({
        onError(error) {
            showErrorToast(getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'));
        },
    });

    const onMarkConnectCalendarDialogAsDismissed = useCallback(async () => {
        // the widget is going to be shown again after a given
        // period of time (controlled through a BE mechanism)
        await markAsDisplayedMutation({
            variables: { widgetClass: UserDisplayedWidgetClassEnum.CalendarReminderWidget },
            refetchQueries: [GetCalendarReminderWidgetDocument],
        });
    }, [markAsDisplayedMutation]);

    return {
        onMarkConnectCalendarDialogAsDismissed,
    };
};
